import moment from "moment";
import { eventTypeCodeDescriptionMap, sharesQuantityTypeCodeDescriptionMap } from "@/app/maps/corporate-actions-maps";

const keyValueMaps = {
	"xri_event_type_code": eventTypeCodeDescriptionMap,
	"xri_shares_quantity_type_code": sharesQuantityTypeCodeDescriptionMap,
};
function mapKeyValue(key, value) {
	const map = keyValueMaps[key];
	return map && map[value] !== undefined ? map[value] : value;
}

export default{
    sidebarWidthPx () {
      return `${this.sidebarWidth}px`
    },
    topPanelHeight () {
      const windowHeight = window.innerHeight
      const height = ((windowHeight * 0.8) * 0.4) - 28  // 28: header
      return `${height}px`
    },
    topEventPanelHeight () {
      const windowHeight = window.innerHeight
      const height = ((windowHeight * 0.8) * 0.6)
      return `${height}px`
    },
    bottomPanelHeight () {
      const windowHeight = window.innerHeight
      const height = ((windowHeight * 0.8) * 0.6) - 92  // 28 + 28 + 36: headers and tabs
      return `${height}px`
    },
    bottomEventPanelHeight () {
      const windowHeight = window.innerHeight
      const height = ((windowHeight * 0.8) * 0.4) - 128  // 28 + 28 + 36 + 36: headers and tabs
      return `${height}px`
    },
    pricingGridHeight () {
      const windowHeight = window.innerHeight
      const height = ((windowHeight * 0.8) * 0.5) - 36  // 28 + 28 + 36 + 36: headers and tabs
      return `${height}px`
    },
    popupContentHeight () {
      return `${(window.innerHeight * 0.8) - 64}px`
    },
    equityReferenceFieldRows () {
      const rows = []
      let columns = []
      this.equityReferenceFields.forEach((field, index) => {
        columns.push(field)
        if (index % 2 === 1) {
          rows.push(columns)
          columns = []
        }
      })
      if (columns.length > 0 && rows[rows.length - 1] != columns) {
        rows.push(columns)
      }
      return rows
    },
    sampleEquityReferenceChangeFields () {
      return this.sampleEquityReferenceChanges.map(row => "int_"+row[3])
    },
    equityCorporateActionsReferenceFieldRows() {
    return this.equityCorporateActionsReferenceFields.map((item) => {
      const keys = Object.keys(item);
      const rows = [];
      for (let i = 0; i < keys.length; i += 2) {
        const key1 = keys[i];
				const val1 = mapKeyValue(key1, item[key1]);

				const row = [key1, val1];
				if (keys[i + 1]) {
					const key2 = keys[i + 1];
					const val2 = mapKeyValue(key2, item[key2]);

					row.push(key2, val2);
				}
				rows.push(row);
      }
      return rows;
    });
  },
    sampleEquityCorporateActionsReferenceChangeFields () {
      return this.sampleEquityCorporateActionsReferenceChanges.map(row => row[2])
    },
    dateRange () {
      const dates = []
      let i = 0
      while((dates.length == 0 || new Date(dates[i-1].value).getTime() < new Date().getTime()) && i<7) {
        const date = moment(this.selectedDate).add(i, 'd')
        dates.push({
          value: date,
          text: date.format(this.dateFormat)
        })
        i++
      }
      if(new Date(dates.at(-1).value).getTime() > new Date().getTime()){
        dates.pop()
      }
      return dates
    }
}